/* eslint-disable max-len */
export default {
  // Karta w ramce jak karty w okienkach („Udostępnij”, „Udostępnione listy”): cienka szara krawędź, zaokrąglone rogi,
  // cień pod spodem. Pola i kolumna obrazka stoją na jej jasnoszarym gradiencie
  wordContainer: {
    marginBottom: '14px',
    border: '1px solid #8c8c8c',
    borderRadius: '8px',
    background: 'linear-gradient(180deg, #dadada, #cbcbcb)',
    boxShadow: '0 3px 8px rgba(0, 0, 0, 0.55)',
  },
  // Jasny pasek nad polami. Wysokość i odstępy w WordsListView.module.less (.wordCard)
  wordContainerHead: {
    // Punkt odniesienia dla przycisku katalogu wyśrodkowanego w nagłówku
    position: 'relative' as const,
    background: 'linear-gradient(180deg, #fbfbfb, #e6e6e6)',
    borderBottom: '1px solid #c2c2c2',
    borderRadius: '7px 0px 0px 0px',
    width: '70%',
  },
  // antd przesuwa treść karty z siatką o 1px w lewo i w górę (chowa linie siatki) — w ramce wchodziłaby na krawędź
  wordContainerBody: {
    margin: 0,
  },
  // wordsEmpty: {
  //   width: '100%',
  //   textAlign: 'center',
  // },
};
